import React from "react";
import { useI18n } from "../../../../i18n/useI18n";
import css from "../../applicationsMagneticStyle.less";

const VqoeLegend = () => {
  const { tViews } = useI18n('views');
  const getLegendLogo = (color, label, labelValue, padding) => (
    <div
      className="vqoe-legend"
      style={{ padding: `${padding}` }}
      data-cy={`${label}`}
    >
      {label === "Unknown" ?
        <span style={{ color: color[1] }} className="legend-span"></span> :
        <>
          <span style={{ color: color[0] }} className="legend-span"></span>
          <span style={{ color: color[1] }} className="legend-span"></span>
          <span style={{ color: color[2] }} className="legend-span"></span>
        </>}
      <span className="label-legend hbr-type-body3">{label}</span>
      <span className="label-legend hbr-type-body4">{labelValue}</span>
    </div>
  );

  return (
    <div className={css["chart-legend"]} data-cy="chart-legend-map-tree">
      {getLegendLogo(
        [
          "var(--hbr-color-success-text-disabled, #c7edb4)",
          "var(--hbr-color-success-icon-weak-selected, #6dc242)",
          "var(--hbr-color-success-border, #45991f)"
        ],
        tViews('appExperienceGoodLabel'),
        tViews('appExperienceGoodValue'),
        "5px 0px"
      )}
      {getLegendLogo(
        [
          "var(--hbr-color-warning-highlight, #fcf5d4)",
          "var(--hbr-color-warning-medium, #e5d067)",
          "var(--hbr-color-warning-border, #cc8604)"
        ],
        tViews('appExperienceFairLabel'),
        tViews('appExperienceFairValue'),
        "5px 10px"
      )}
      {getLegendLogo(
        [
          "var(--hbr-color-danger-disabled, #f0b3aa)",
          "var(--hbr-color-danger-weak, #f08878)",
          "var(--hbr-color-danger, #CC2D37)"
        ],
        tViews('appExperiencePoorLabel'),
        tViews('appExperiencePoorValue'),
        "5px 0px"
      )}
      {getLegendLogo(
        [
          "var(--hbr-color-neutral-border, #889099)",
          "var(--hbr-color-neutral-border, #889099)",
          "var(--hbr-color-neutral-border, #889099)"
        ],
        tViews('appExperienceUnknownLabel'),
        tViews('appExperienceUnknownValue'),
        "5px 0px"
      )}
    </div>
  );
};
export default VqoeLegend;
